export function expect(
  truthy: boolean | string,
  message: string,
  ...args: unknown[]
) {
  if (!Boolean(truthy)) {
    console.error(message, args)

    if (import.meta.env.DEV) {
      debugger
      throw new Error(message)
    }
  }
}
